<template>
    <div class="salesStatistics">
        <div class="salesStatisticsBox">
            <div class="top-echarts-two">
                <div class="echarts-left echarts-total">
                    <div class="title-box">
                        <h1>本期实收</h1>
                    </div>
                    <div style="width 100%;height:300px;flex 4" id="contractQuantityId"></div>
                </div>
            </div>
            <!-- 导出excel -->
            <exportDom :dom-id="'.el-table__fixed'" :excel-name="'月度应收账款'"></exportDom>
            <div class="table-list">
                <el-table
                    :data="tabListDataName"
                    style="width: 100%"
                    max-height="330"
                    show-summary
                    ref="tableRef"
                    :summary-method="getSummaries"
                >
                    <el-table-column
                        prop="name"
                        label="销售分公司"
                        width="150"
                        fixed
                    >
                    </el-table-column>
                    <el-table-column
                        v-for="(date, index) in tabListDataDate"
                        :key="index"
                        :label="date"
                    >
                        <el-table-column
                            label="本期应收(元)"
                            :prop="date"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <span v-for="(key, idx) in scope.row.list" :key="idx">
                                    <template v-if="key.date === date">
                                        {{ key.bqys }}
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="本期实收(元)"
                            :prop="date"
                            width="120"
                        >
                            <template slot-scope="scope">
                                <span v-for="(key, idx) in scope.row.list" :key="idx">
                                    <template v-if="key.date === date">
                                        {{ key.bqss }}
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="当月货款回收率(%)"
                            :prop="date"
                            width="140"
                        >
                            <template slot-scope="scope">
                                <span v-for="(key, idx) in scope.row.list" :key="idx">
                                    <template v-if="key.date === date">
                                        {{ key.hkhsl }}
                                    </template>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import exportDom from './../salesStatistics/components/export';
// import addBgImages from '../utils';
export default {
    components: {
        exportDom,
    },
    data() {
        return {
            showContract: false,
            showYearData: false,
            alertStatus: 0,
            tabListData: {},
            tabListDataName: [],
            tabListDataList: [],
            tabListDataDate: [],
            tabListEchartsHt: [],

            echartsColor: ['#EA8343', '#3E79C4', '#E6E429', '#FA9E94'],
        };
    },
    mounted() {
        this.$nextTick(async () => {
            // 月度应收账款
            await this.salescontractMonths();
            await this.$refs.tableRef.doLayout();
        });
    },
    methods: {
        getSummaries(param) {
            const { columns } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                // 获取与当前行时间相同的数据
                const arr = this.tabListDataList.filter(item => {
                    return column.property === item.date;
                });
                // 对应时间合同数量和预计本期应收(元)的数值数组 // 对应每一列的数据数组
                // eslint-disable-next-line consistent-return
                const values = arr.map(item => {
                    if (column.label === '本期应收(元)') {return item.bqys;}
                    if (column.label === '本期实收(元)') {return item.bqss;}
                });
                // const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;

                    }, 0);
                } else {
                    sums[index] = ' ';
                    if (column.label === '当月贷款回收率(%)') {
                        sums[index] = !Number(sums[index - 2]) ? ' ' : (sums[index - 1] / sums[index - 2]).toFixed(2);
                    }
                }
            });
            return sums;
        },
        // 本期应收
        contractQuantityCh(data) {
            const myChart = this.$echarts.init(document.getElementById('contractQuantityId'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                legend: {
                    data: this.tabListEchartsHt,
                    padding: [10, 0, 0, 0],
                },
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.tabListDataDate,
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        axisTick: {
                            show: false,
                        },
                        nameTextStyle: {
                            color: '#666666',
                            fontSize: 10,
                            padding: [10, 0, 0, 0],
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                fontSize: 10,
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                                type: 'dashed',
                            },
                        },
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        nameTextStyle: {
                            color: '#666666',
                            fontSize: 10,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#D7D7D7',
                            },
                        },
                        splitLine: { show: false },
                    },
                ],
                series: data,
            };
            const that = this;
            myChart.on('click', function () {
                that.showYearData = true;
            });
            myChart.setOption(option, true);
        },
        // 月度应收账款
        async salescontractMonths() {
            await this.$axios
                .get('/interfaceApi/report/financialanalysis/ydyszk?date=&datenum=12')
                .then(res => {
                    this.tabListData = res;
                    this.tabListDataList = this.tabListData.list;
                    this.tabListDataDate = this.tabListData.date;
                    // 表格渲染
                    this.tabListDataName = this.tabListData.name.map(item => {
                        const arr = this.tabListData.list.filter(key => {
                            return key.name === item;
                        });
                        return {
                            name: item,
                            list: arr,
                        };
                    });
                    // 处理图表数据
                    this.tabListEchartsHt = this.tabListData.name;
                    this.tabListEchartsHt.push('合计回款率');
                    // 分组名称
                    const getSeriesData = this.tabListData.name.map(item => {
                        const arr = this.tabListData.list.filter(key => {
                            return key.name === item;
                        });
                        return arr;
                    });
                    // 本期实收
                    let htEchartSeriesData = [];
                    htEchartSeriesData = getSeriesData.map((item, index) => {
                        let htItemListData = [];
                        htItemListData = item.map(info => {
                            return info.bqss || 0;
                        });
                        const arrName = this.tabListEchartsHt[index];
                        const arrColor = this.echartsColor[index];
                        const htEchartSeries = {
                            name: arrName,
                            type: 'bar',
                            data: htItemListData,
                            label: {
                                fontFamily: 'QuartzLTStd',
                                show: true,
                                position: 'top',
                                color: arrColor,
                                fontSize: '14',
                                padding: 5,
                                // backgroundColor: {
                                //     image: addBgImages(index, 'top'),
                                // },
                            },
                            itemStyle: {
                                color: arrColor,
                            },
                        };
                        return htEchartSeries;
                    });
                    // 本期应收合计
                    const htTotalData = this.tabListData.date.map(item => {
                        const arr = this.tabListData.list.filter(key => {
                            return key.date === item;
                        });
                        // 实收
                        let bqsss = 0;
                        // 应收
                        let bqyss = 0;
                        arr.forEach(a => {
                            bqsss = Math.round(bqsss + a.bqss * 100);
                            bqyss = Math.round(bqyss + a.bqys * 100);
                        });
                        return (bqsss / bqyss).toFixed(2);
                    });
                    const htTotal = {
                        name: '合计回款率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: htTotalData,
                        label: {
                            fontFamily: 'QuartzLTStd',
                            show: true,
                            position: 'top',
                            fontSize: '14',
                            padding: 5,
                            // backgroundColor: {
                            //     image: addBgImages(2, 'top'),
                            // },
                        },
                        itemStyle: {
                            normal: {
                                color: '#73DABE',
                            },
                        },
                    };
                    const htCompleteData = htEchartSeriesData.slice(0, -1);
                    htCompleteData.push(htTotal);
                    // 本期应收图表
                    this.contractQuantityCh(htCompleteData);
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.message);
                });
        },
    },
};

</script>
<style lang='stylus'>
.salesStatistics
    height 100%
.salesStatisticsBox
    height 100%
    display flex
    padding 20px
    display flex
    flex-direction column
    background #fff
    .el-table__fixed-right thead tr th
        &:last-child
            background #F5F2ED !important
            color #823802 !important
        &:nth-last-child(2)
            background #F5F2ED !important
            color #823802 !important
         &:nth-last-child(3)
            background #F5F2ED !important
            color #823802 !important
    .el-table__fixed-body-wrapper tbody tr td
        &:last-child
            color #C9661E !important
        &:nth-last-child(2)
            color #C9661E !important
        &:nth-last-child(3)
            color #C9661E !important
    .el-table__fixed-footer-wrapper table tbody tr
        td
            background none
            color #C9661E
            &:first-child
                background #F5F2ED
                color #823802
                font-size 16px
    .el-table__footer-wrapper table tbody td
        background none
        color #C9661E
    .top-echarts-two
        display flex
        // flex 1
        width 100%
        height 50%
        // height 600px
        .echarts-total
            flex 1
            // width 100%
            // height 50%
            padding 20px
            border 1px solid #D7D7D7
            display flex
            flex-direction column
            .title-box
                display flex
                justify-content space-between
                flex 1
                h1
                    color #333333
                    font-size 18px
                    &:before
                        content '`'
                        width 6px
                        height 20px
                        background #4D7DE0
                        color #4D7DE0
                        margin-right 10px
                span
                    color #1577D2
                    height 25px
                    padding 0 20px;
                    font-size 14px
                    cursor pointer
                    border 1px solid #1577D2
        .echarts-left
            margin-right 20px
    .table-list
        margin-top 10px
        width 100%
        height 50%
        padding-bottom 20px
        .el-table
            .el-table__header
                border-collapse: collapse;
            thead tr th
                color #022782
                font-size 16px
                text-align center
                padding 0
            tbody tr td
                height 40px
                text-align center
                padding 0
                font-size 14px
</style>